module.exports = __webpack_public_path__ + "static/media/skruva.1b35bf27.mp3";